import React, { useState, useEffect } from 'react';
import {
  Navigate,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from 'react-router-dom';

import Header from '../../common/Header';
import { Tabs } from '../../common/Tabs';

import { settingsTabs } from './constants/constants';
import { Integrations } from './Integrations';
// import { PerformanceSettings } from './PerformanceSettings'; // TODO: Uncomment when re-enabling Performance Settings
import { TeamSettings } from './TeamSettings';

export function SettingsPage(): JSX.Element {
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname.split('/').pop();
    const tabIndex = settingsTabs.findIndex((tab) => tab.value === currentPath);
    if (tabIndex !== -1) {
      setSelectedTab(tabIndex);
    }
  }, [location.pathname]);

  return (
    <div className="flex flex-col  items-start gap-2 self-stretch mt-4 max-w-screen-l h-full mx-auto">
      <Header>Settings</Header>
      <Tabs
        items={settingsTabs}
        selectedIndex={selectedTab}
        onChange={(index, value) => {
          setSelectedTab(index);
          if (value) {
            navigate(`/settings/${value}`);
          }
        }}
        className="w-full"
      />
      <Routes>
        <Route path="teamSettings" element={<TeamSettings />} />
        <Route path="integrations" element={<Integrations />} />
        {/* TODO: Re-enable Performance Settings route in a month */}
        {/* <Route path="performanceSettings" element={<PerformanceSettings />} /> */}
        <Route path="*" element={<Navigate to="teamSettings" replace />} />
      </Routes>
    </div>
  );
}
